'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = FreePlanLink;

require('./free-plan-link.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function FreePlanLink() {

    var url = '/info/chooseFreeOrEnterpriseSignupPlan';

    return _react2['default'].createElement(
        'div',
        { className: 'm-free-plan-link' },
        'Just need to sign a document? Try our',
        _react2['default'].createElement(
            'a',
            { href: url },
            ' free plan.'
        )
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/choose-signup-plan/v2/free-plan-link.jsx
 ** module id = 1174
 ** module chunks = 0
 **/